/**
 * Apple-style 8-dot fading spinner. Sizes via the parent's `font-size`
 * (the dots use currentColor and percent-of-box dimensions).
 */
export function Spinner({
  size = 24,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`ios-spinner ${className}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Lädt"
    >
      {Array.from({ length: 8 }, (_, i) => (
        <i key={i} />
      ))}
    </span>
  );
}
